import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FlowActionCardComponent } from '../flow-action-card/flow-action-card.component';

@Component({
  selector: 'app-flow-stop-action',
  imports: [FlowActionCardComponent],
  templateUrl: './flow-stop-action.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlowStopActionComponent {}
